export const innerHTML = `<svg width="18" height="18" viewBox="0 0 18 18">
<path fill-rule="evenodd" clip-rule="evenodd" d="M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM5.37561 7V5H13.3756V13H11.3756V8.62793L6.52692 13.4766L5 11.9497L9.94971 7H5.37561Z"/>
</svg>`;

